import { buildASOPath } from "lib/resource-finder/resource-finder";

/**
 * Return URL for an EOR employee finishing a profile edit in clockface.
 *
 * Bridge: clockface is being decommissioned (June 2026). EOR members land
 * read-only on the neon-dash account-settings summary, so save/cancel/back must
 * return them there rather than to a clockface-internal page. Unconditional by
 * design — the neon-dash summary renders for everyone, so this cannot trap or
 * loop a user.
 */
export function eorMemberSettingsReturnUrl(): string {
  return buildASOPath("/account/settings/basic-information");
}
